function TitleCard({ title, content }) {
  return (
    <div className="titleCard card">
      <h4 className="mb-2" dangerouslySetInnerHTML={{ __html: title }}></h4>
      <p className="mb-0" dangerouslySetInnerHTML={{ __html: content }}></p>
    </div>
  );
}
export default TitleCard;
